import {ClassComponent, Vnode} from 'mithril';
import listItems from 'flarum/common/helpers/listItems';
import Form from '../models/Form';

interface FormTitleAttrs {
    form: Form
}

export default class FormTitle implements ClassComponent<FormTitleAttrs> {
    view(vnode: Vnode<FormTitleAttrs, this>) {
        const {form} = vnode.attrs;
        const badges = form.badges().toArray();

        return m('h2.App-titleControl', [
            form.title(),
            ' ',
            badges.length ? m('ul.FormulaireDataTable-badges.badges', listItems(badges)) : null,
        ]);
    }
}
